
<div class="trg-btn-content">
  <div class="trg-btn-left">
    <div class="trg-btn-left-icon" #trgBtnIcon [hidden]="trgBtnIconEmpty()">
      <ng-content select="i:not([btnRight]), svg:not([btnRight]), [btnIcon]"></ng-content>
    </div>
    <div class="trg-btn-text" #trgBtnText [hidden]="trgBtnTextEmpty()">
      <ng-content></ng-content>
    </div>
  </div>
  <div class="trg-btn-right" #trgBtnRight [hidden]="trgBtnRightEmpty()">
    <ng-content select="[btnRight]"></ng-content>
  </div>
</div>
